import * as Sentry from '@sentry/react';

import type Track from 'bundles/interactive-transcript/models/Track';
import { loadTrack } from 'bundles/interactive-transcript/utils/TrackUtils';

type Payload = { track: Track; trimRange?: { trimmedStartTimeSeconds: number; trimmedEndTimeSeconds: number } };

export const getVideoTranscript = ({ dispatch }: $TSFixMe, { track, trimRange }: Payload) => {
  return loadTrack(track, trimRange?.trimmedStartTimeSeconds, trimRange?.trimmedEndTimeSeconds).then(
    (videoTranscript) => dispatch('RECEIVE_TRANSCRIPT', videoTranscript),
    (error) => Sentry.captureException(error, { extra: { track } })
  );
};

export default {
  getVideoTranscript,
};
